import { ReactNode } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    listStyle: 'none',
  },
  fill: {
    flex: 1,
  },
  content: {
    ...theme.fonts.calendarTitle,
    textTransform: 'uppercase',
    color: theme.colors.inkSecondary,
  },
  children: {
    marginTop: theme.marginBase,
  },
}));

interface Props {
  text?: ReactNode;
  children?: ReactNode;
  fill?: boolean;
}

export const OfferItem = ({ text, fill, children }: Props) => {
  const classes = useStyles();

  return (
    <li
      className={classNames(classes.container, {
        [classes.fill]: !!fill,
      })}
    >
      <div className={classes.content}>{text}</div>
      {!!children && <div className={classes.children}>{children}</div>}
    </li>
  );
};
